
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.977 5.164l.015-.195c.016-.25.024-.466.024-.649 0-.427-.026-.812-.079-1.156a2.889 2.889 0 00-.265-.883c-.12-.25-.284-.44-.492-.57-.203-.135-.461-.203-.774-.203-.38 0-.734.091-1.062.273-.323.177-.64.453-.953.828h-.563v-.648c.495-.349.878-.596 1.149-.742.276-.151.549-.263.82-.336a3.51 3.51 0 01.898-.11c.87 0 1.521.297 1.953.891.433.589.649 1.482.649 2.68 0 .474-.042 1.039-.125 1.695-.083.651-.224 1.33-.422 2.04-.198.707-.427 1.309-.688 1.804-.26.495-.549.904-.867 1.226a3.393 3.393 0 01-1.101.75 3.505 3.505 0 01-1.399.266c-.526 0-.981-.107-1.367-.32a2.119 2.119 0 01-.875-.938C.255 10.456.156 9.953.156 9.36c0-.583.091-1.161.274-1.734a5.254 5.254 0 01.797-1.57 4.002 4.002 0 011.257-1.117 3.194 3.194 0 011.57-.407c.376 0 .704.045.985.133.281.083.594.25.938.5zm-.375 1.5c0-.531-.11-.917-.329-1.156-.213-.24-.541-.36-.984-.36-.318 0-.622.084-.914.25a2.51 2.51 0 00-.773.704c-.23.307-.422.664-.579 1.07a8.67 8.67 0 00-.359 1.242A6.64 6.64 0 001.54 9.72c0 .469.05.836.149 1.101.104.26.24.44.406.54.166.098.375.148.625.148.562 0 1.041-.224 1.437-.672.401-.453.742-1.13 1.024-2.031.28-.907.422-1.62.422-2.14z","fill":"currentColor"}})])
          )
        }
      }
    